<template>
  <div
    class="news"
    v-on:click="goTodetail(item, $event)"
    :class="item.category != null ? item.category.name : ''"
  >
    <div class="slider-overlay" v-if="item.class == 'extended' && !mobile">
      <swiper :options="newsOptions" ref="mySwiper">
        <swiper-slide v-for="(i, index) in item.images" :key="index">
          <div
            :style="{
              backgroundImage: 'url(' + require(`@/assets/` + i) + ')',
            }"
          ></div>
        </swiper-slide>
      </swiper>
      <app-swiper-btn :name="title"></app-swiper-btn>
    </div>
    <div v-else class="img">
      <div :style="{ backgroundImage: 'url(' + mainImage + ')' }"></div>
    </div>

    <div>
      <span class="category" v-if="item.category != null">{{
        item.category.name
      }}</span>
      <h5 class="white">{{ item.title }}</h5>
      <p class="date">
        <span class="icon icon_hour" v-if="!icon"></span>
        <span class="icon icon_data" v-else></span>
        <span>{{ changeDate }}</span>
      </p>
      <video-btn
        :btnType="'news'"
        :videoLink="item.videoLink"
        class="video-btn"
      ></video-btn>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Swiper_button from "@/components/shared/Swiper_button";
import NewsVideo from "./Video-btn";
export default {
  data() {
    return {
      icon: true,
      newsOptions: {
        slidesPerView: 3,
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: ".next-image",
          prevEl: ".prev-image",
        },
      },
      title: {
        nextEl: "sw-btn next-image",
        prevEl: "sw-btn prev-image",
      },
      breakpoints: {
        1199: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      },
    };
  },
  props: {
    item: Object,
    classVal: {
      type: String,
      default: "",
    },
  },
  computed: {
    mobile() {
      return this.$store.state.mobile;
    },
    mainImage() {
      var image;
      if (this.item.images) {
        var mas = this.item.images.length;
        this.item.images.forEach((element, index) => {
          if (index === 0) {
            image = element.imageUrl;
          }
        });
      }
      return image;
    },
    changeDate() {
      if (moment().isSame(this.item.createdAt, "day")) {
        this.icon = false;
        return moment(this.item.createdAt).utc().startOf("hour").fromNow();
      }
      return moment(this.item.createdAt).utc().format("MMM DD YYYY");
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    goTodetail(newsId, event) {
      if (
        event.target.tagName == "svg" ||
        event.target.tagName == "path" ||
        event.target.classList.contains("sw-btn") ||
        event.target.parentElement.classList.contains("btn-wrapper") ||
        event.target.parentElement.classList.contains("btn")
      ) {
        return false;
      } else {
        this.$router.push({ name: "single-news", params: { id: newsId.id } });
      }
    },
  },
  components: {
    swiper,
    swiperSlide,
    "app-swiper-btn": Swiper_button,
    "video-btn": NewsVideo,
  },
};
</script>
<style lang="scss" scoped>
.slider-default {
  .news {
    .img {
      width: 100%;
      @media only screen and (max-width: 499px) {
        height: 25rem;
      }
    }
  }
}

.news {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  div {
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    &.slider-button {
      position: absolute;
      width: calc(100% - 4rem);
      left: 2rem;
      margin: 0;
      z-index: 98;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      justify-content: space-between;
    }
  }
  .img {
    display: block;
    width: 27rem;
    min-height: 20.5rem;
    height: 20.5rem;
    border-radius: 4px;
    margin-bottom: 3rem;
    position: relative;
    min-width: 20rem;
    max-width: 100%;
    overflow: hidden;
    div {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      transition: all 0.3s ease-in-out;
    }
    .photo {
      width: 100%;
      min-height: 20.5rem;
    }
    @media only screen and (max-width: 992px) {
      width: 22rem;
      height: 16.5rem;
      min-height: 16.5rem;
    }
    @media only screen and (max-width: 768px) {
      width: 30rem;
      height: 20rem;
      min-height: 16.5rem;
    }
    @media only screen and (max-width: 599px) {
      margin-bottom: 1rem;
    }
  }

  h5 {
    min-height: 5rem;
    margin-bottom: 2rem;
    font-weight: 700;
    transition: all 0.3s ease-in-out;
    @media only screen and (max-width: 599px) {
      min-height: auto;
    }
  }
  @media only screen and (min-width: 768px) {
    &:hover {
      h5 {
        opacity: 0.7;
      }
      .img {
        div {
          transform: scale(1.1);
        }
      }
    }
  }

  .date {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: #a8a8a8;
    span {
      font-size: 1.2rem;
      line-height: 0;
      font-weight: 400;
      text-transform: uppercase;
      @media only screen and (max-width: 768px) {
        font-size: 1.6rem;
      }
    }
  }
  .category {
    text-transform: capitalize;
    display: none;
    color: #a8a8a8;
  }
  .icon {
    display: inline-block;
    width: 1.5rem;
    height: 1.5rem;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    margin-right: 1rem;
    &_hour {
      background-image: url("./../../assets/img/hour-icon.svg");
    }
    &_data {
      background-image: url("./../../assets/img/date-icon.svg");
    }
  }
  @media only screen and (min-width: 769px) {
    &.extended {
      display: flex;
      flex-direction: row-reverse;
      & > div {
        width: 23%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        &.slider-overlay {
          position: relative;
          display: block;
          width: 77%;
          overflow: hidden;
          padding-left: 3%;
        }
      }
      .swiper-container {
        height: 32rem;
        overflow: visible;
        @media only screen and (max-width: 1199px) {
          height: 25rem;
        }
        .swiper-slide {
          width: 37rem !important;
          @media only screen and (max-width: 1199px) {
            width: 32rem !important;
          }
        }
        .swiper-slide div {
          height: 32rem;
          width: 100%;
          background-repeat: no-repeat;
          background-size: cover;
          @media only screen and (max-width: 1199px) {
            height: 25rem;
          }
        }
      }
    }
  }
}
</style>